import { Config, Culture, ErrorHandling, TranslationConfig } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import DOMPurify from "dompurify";

Config.rootNamespaces.push('ERPAdmin');
TranslationConfig.getLanguageList = () => getLanguageList().map(x => ({ id: x.id ?? '', text: x.text ?? '' }));
(globalThis as any).DOMPurify = DOMPurify;
gridDefaults.sanitizer = DOMPurify.sanitize;

// Display all dates as dd/MM/yyyy — set ALL four properties so formatDate,
// flatpickr (DateEditor), and parseDate all agree on the same dmy ordering.
Culture.dateFormat = 'dd/MM/yyyy';
Culture.dateTimeFormat = 'dd/MM/yyyy HH:mm';
Culture.dateOrder = 'dmy';
Culture.dateSeparator = '/';

const l10ns = flatpickr.l10ns as Record<string, any>;
let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (l10ns[culture]) {
    flatpickr.localize(l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    l10ns[culture] && flatpickr.localize(l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler as OnErrorEventHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);